
import { Transaction } from '@/types/payment';
import { supabase } from '@/integrations/supabase/client';

/**
 * Check if the client already exists in the system
 * @param recipientId The ID of the recipient
 * @returns Whether the client exists
 */
export const isExistingClient = async (recipientId: string): Promise<boolean> => {
  try {
    // Check if the recipient exists in the database
    // Use specific typings to avoid excessive deep instantiation
    const { data, error } = await supabase
      .from('profiles')
      .select('id')
      .eq('id', recipientId)
      .maybeSingle();
    
    if (error) {
      console.error('Error checking client:', error);
      return false;
    }
    
    return !!data;
  } catch (error) {
    console.error('Error in isExistingClient:', error);
    return false;
  }
};

/**
 * Process an immediate transfer for verified clients
 * @param transaction The transaction data
 * @returns Whether the transfer was successful
 */
export const processImmediateTransfer = async (
  transaction: Transaction
): Promise<boolean> => {
  try {
    const exists = await isExistingClient(transaction.recipient);
    
    if (!exists) {
      console.log('Recipient not found for immediate transfer');
      return false;
    }
    
    // For existing clients, process an immediate transfer
    console.log(`Processing immediate transfer to ${transaction.recipient} for amount $${transaction.amount}`);
    
    // In a real system, this would call a payment processing API
    // For demo purposes, we're just logging and returning success
    return true;
  } catch (error) {
    console.error('Error processing immediate transfer:', error);
    return false;
  }
};
